import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IWelcome = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg width="20" height="18" viewBox="0 0 20 18" fill="none" >
            <path
              d="M7.97729 16.6703V10.9512H12.0951V16.6703"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M3.74519 6.71875V14.8399C3.70706 15.6025 4.08833 17.1047 5.91845 17.0132C7.74858 16.9217 12.0189 16.9751 13.9252 17.0132C14.7259 17.0513 16.3501 16.67 16.4417 14.8399C16.5332 13.0098 16.4798 8.66325 16.4417 6.71875"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M1 8.66363L9.92184 1L19.0724 8.66363"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IWelcome;
